import React from 'react';
import Utils from '../../utils/Utils';
import { UiTag, type UiTagProps } from './UiTag';
import FeaturedIcon from '../icons/FeaturedIcon';

type FeaturedTagProps = Omit<UiTagProps, 'label' | 'color' | 'icon'> & {
  label?: string;
};

export const FeaturedTag: React.FC<FeaturedTagProps> = ({
  label = 'Featured',
  className,
  ...props
}) => {
  return (
    <UiTag
      label={label}
      color="custom"
      className={Utils.cn(
        'h-6 px-[10px] py-[2px] rounded-full text-ai-purple bg-brand-50',
        className,
      )}
      icon={<FeaturedIcon className="w-3 h-3" />}
      {...props}
    />
  );
};

FeaturedTag.displayName = 'FeaturedTag';

export default FeaturedTag;
